export default "__VITE_ASSET__6cd43057__"